import styled, { css } from 'styled-components';
import * as Grid from 'components/Grid';

export const Container = styled(Grid.Container)`
  width: 100%;
  height: 690px;
  padding: 0 5% !important;
`;

export const Content = styled.div`
  width: 480px;
`;

const TextStyle = css`
  margin-bottom: 42px;
  color: #fff;
  text-align: ${({ center }) => center ? 'center' : 'left'};
`;

export const Title = styled.h1`
  ${TextStyle}
`;

Title.xs = styled.h3`
  ${TextStyle}
`;

export const Text = styled.h4`
  ${TextStyle}
`;

Text.xs = styled.h5`
  ${TextStyle}
  max-width: 300px;
`;

export const GetInTouch = styled.p`
  font-weight: 600;
  color: #fff;

  & > u {
    cursor: pointer;
    margin-left: 24px;

    &:hover{
      opacity: 0.7;
    }
  }
`;

export const ContactSales = styled.p`
  cursor: pointer;
  text-decoration: underline;
  color: #fff;
`;

export const Share = styled.p`
  color: #fff;
`;

export const Icon = styled.img`
  cursor: pointer;
  display: inline-block;
  width: 24px;
  height: 24px;

  &:hover {
    opacity: 0.7;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const ShareButton = styled.button`
  background: none;
  border: none;
  outline: none;
`;